import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let registered = {
  firstname: localStorage.getItem("firstname"),
  lastname: localStorage.getItem("lastname"),
  company: localStorage.getItem("company"),
  email: localStorage.getItem("email"),
}

export default new Vuex.Store({
  state: {
    regInfo: {
      firstname: registered.firstname?registered.firstname:"",
      lastname: registered.lastname?registered.lastname:"",
      email: registered.email?registered.email:"",
      company: registered.company?registered.company:""
    }
  },
  mutations: {
    register: (state, info) => {
      localStorage.setItem("firstname", info.firstname);
      localStorage.setItem("lastname", info.lastname);
      localStorage.setItem("company", info.company);
      localStorage.setItem("email", info.email);
    }
  },
  actions: {
  },
  modules: {
  }
})
